class MatchAddShotsVisualController {

	constructor(MatchesFactory, $rootScope, $filter, $state){
		'ngInject';
		const vm = this;

		vm.rootScope = $rootScope;
		vm.$onInit = () => {
			$state.current.data.hideSidebar = true;
			$state.current.data.hideMatchProfile = true;
			$state.current.data.hideMatchMenu = true;
			vm.activeRoundIdentifier = 1;
			vm.ends = [1, 2, 3, 4, 5, 6];
			if(vm.rootScope.currentMatch.match_type === MatchesFactory.MATCH_TYPES.INDOOR){
				vm.ends = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
			}
			reloadMatchData();
		};

		vm.isEndCompleted = (targetName, shotEnd) => {
			let mP = vm.matchPlayers.find(m => m.target_name === targetName);
			let round = mP.rounds.find(r => r.round === vm.activeRoundIdentifier);
			if(vm.rootScope.currentMatch.match_type === MatchesFactory.MATCH_TYPES.INDOOR){
				return (round['arrow_' + shotEnd + '_1'] &&
					round['arrow_' + shotEnd + '_2'] &&
					round['arrow_' + shotEnd + '_3']) ? 'success' : 'danger';
			}else{
				let arOne = 1;
				let arTwo = 2;
				if(shotEnd === 2){
					arOne = 3;
					arTwo = 4;
				}else if(shotEnd === 3){
					arOne = 5;
					arTwo = 6;
				}else if(shotEnd === 4){
					arOne = 7;
					arTwo = 8;
				}else if(shotEnd === 5){
					arOne = 9;
					arTwo = 10;
				}else if(shotEnd === 6){
					arOne = 11;
					arTwo = 12;
				}
				return (round['arrow_' + arOne + '_1'] &&
					round['arrow_' + arOne + '_2'] &&
					round['arrow_' + arOne + '_3'] &&
					round['arrow_' + arTwo+ '_1'] &&
					round['arrow_' + arTwo + '_2'] &&
					round['arrow_' + arTwo + '_3']) ? 'success' : 'danger';
			}
		};

		vm.selectRound = (identifier) => {
			vm.activeRoundIdentifier = identifier;
		};

		function reloadMatchData(){
			let data = {include: 'matchPlayers,matchPlayers.rounds'};
			MatchesFactory.getOne(vm.rootScope.currentMatchId, data, true)
						  .then(response => {
							  vm.matchPlayers = response.data.matchPlayers;
							  vm.matchPlayers.sort((a, b) => {
								  if(a.target_name < b.target_name)
									  return -1;
								  if(a.target_name > b.target_name)
									  return 1;
								  return 0;
							  });
							  setTimeout(reloadMatchData, 2000);
						  });
		}
	}
}

export default MatchAddShotsVisualController;



// WEBPACK FOOTER //
// ./client/app/components/matches/matchProfile/matchAddShotsVisual/matchAddShotsVisual.controller.js